import React from "react";
import { useUiPack } from "@/hooks/useUiPack";
import Dashboard from "@/pages/Dashboard";
import SimpleHome from "@/pages/simple/SimpleHome";

export default function UiPackHome() {
  const { isSimple } = useUiPack();
  return isSimple ? <SimpleHome /> : <Dashboard />;
}
